import widget_ru from '../assets/widget_ru.png';
import widget_kz from '../assets/widget_kz.png';
import widget_en from '../assets/widget_en.png';
import widget2_ru from '../assets/widget2_ru.png';
import widget2_kz from '../assets/widget2_kz.png';
import widget2_en from '../assets/widget2_en.png';
import widget3_ru from '../assets/widget3_ru.png';
import widget3_kz from '../assets/widget3_kz.png';
import widget3_en from '../assets/widget3_en.png';
import widget4_ru from '../assets/widget4_ru.png';
import widget4_kz from '../assets/widget4_kz.png';
import widget4_en from '../assets/widget4_en.png';
import widget5_ru from '../assets/widget5_ru.jpg';
import widget5_kz from '../assets/widget5_kz.jpg';
import widget5_en from '../assets/widget5_en.jpg';
import widget6_ru from '../assets/widget6_ru.png';
import widget6_kz from '../assets/widget6_kz.png';
import widget6_en from '../assets/widget6_en.png';

const ogpovtsResources = {
  en: {
    ogpovts: {
      is_beneficiary: 'Является выгодоприобретателем',

      bannerOgpoJusan: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/failure_W_2016х158_en.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/failure_B_2016х158_en.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/failure_W_343x100_en.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/failure_B_343x100_en.png',
      },
      title: 'Compulsory insurance of civil liability of vehicle owners',
      calculator: 'Insurance calculator',
      'description.title': 'Description',
      'description.text':
        'In the absence of a policy, an enormous fine is provided. This policy covers your civil liability in case of an accident where you are guilty. The insurance company assumes the costs of compensation for damage to the injured party.\n\nEach owner, driver of a vehicle must insure driver’s liability in accordance with the Law of the Republic of Kazakhstan No. 446-II dated 01.07.2003 "On compulsory insurance of civil liability of vehicle owners".',
      cars: 'Cars',
      'cars.add': 'Add car',
      drivers: 'Drivers',
      drivers2: 'Водители (укажите собственника авто)',
      'drivers.add': 'Add driver',
      '12months': '12 months',
      '6months': '6 months',
      period: 'Insurance period',
      date: 'Contract start date',
      dateEnd: 'End date of the contract',
      benefit: 'Benefit',
      agree: 'I confirm my consent to ',
      'agree.color3': 'the collection and processing of personal data',
      'agree.color4':
        'the terms of compulsory motor third-party liability insurance',
      'agree.color5': 'the terms of accident insurance ',
      'agree.color6': 'the terms of title insurance ',
      'agree.color88': ' voluntary car insurance',
      agree3: ', agree with ',
      'agree.color': 'the insurance rules',
      'agree.color2': 'the terms of the promotion ',
      agree2: "and I'm familiar with the ",
      'agree2.color': 'privacy policy',
      snackbarError: 'Error. Please try again later',
      snackbarDownload: 'The file is downloading, please wait',
      price: 'Pay:',
      button: 'Buy',
      or: 'or',
      and: ' and ',
      IIN: 'IIN',
      promotion:
        'Choose a promotion from our company. By choosing a promotion, you agree with the terms of the promotion',
      promotion2:
        'ТОЛЬКО 24 НОЯБРЯ! Согласно специальному событию "Orange Friday" к выбранной акции вы получите 10 литров бензина! Подробнее ',
      'promotion2.button': 'здесь',
      phoneNumber1: "Enter the policyholder's phone number:",
      phoneNumber2: 'Phone number',
      SMS: 'Send SMS code',
      cancel: 'Cancel',
      validate1: 'Incorrect car number',
      validate2: 'Enter the state number of the car',
      validate3: 'The IIN must consist of 12 characters',
      validate4: 'Technical problem, try again later',
      validate5:
        'The format of the state number does not correspond to the format A000AAA or 000AAA00',
      widget1: widget_en,
      widget2: widget2_en,
      widget3: widget3_en,
      widget4: widget4_en,
      widget5: widget5_en,
      widget6: widget6_en,
      bmgError:
        'Another phone number has been confirmed for the current IIN in the personal account of the site egov.kz. Enter the correct phone number',
      mcPr1:
        'By confirming this application form, I give my consent to the conclusion of a voluntary automobile insurance policy',
      mcPr2:
        'By confirming this application form, I give my consent to the conclusion of a voluntary automobile insurance policy and a voluntary title insurance policy',
      heIsdriver: 'Он же водитель',
      insurant_label: '(Страхователь)',
      driver_label: '(Водитель)',
      application_success: 'Заявка успешно отправлена!',
      application_followup: 'С вами свяжутся в ближайшее время',
      'ОГПО ВТС': 'ОГПО ВТС',
      'Несчастный случай': 'Несчастный случай',
      НС: 'НС',
      'Страховка от несчастного случая': 'Страховка от несчастного случая',
      'Страховая сумма на одного застрахованного':
        'Страховая сумма на одного застрахованного',
      'Территория страхования': 'Территория страхования',
      'Срок страхования': 'Срок страхования',
      'Количество застрахованных': 'Количество застрахованных',
      'Дата начала договора': 'Дата начала договора',
      Закрыть: 'Закрыть',
      месяцев: 'месяцев',
      'Сбросить на 12 мес.': 'Reset to 12 months',
    },
    cascoLimit: {
      sumInsured: 'Sum insured',
      termOfInsurance: 'Insurance period',
      months: '12 months',
      purposeOfUse: 'Purpose of use',
      personal: 'Personal',
      other: 'Other',
      beneficiary: 'Beneficiary (Vehicle Owner)',
      yourVehicles: 'Your vehicles',
      detailsTitle: 'Policy details',
      detailsDescription: 'Please check the policy data for correctness',
      insuredCount: 'Number of insured persons',
      regNumber: 'Vehicle number',
      startDate: 'Contract start date',
      endDate: 'Contract end date',
      premium: 'Premium',
      not_selected_manual: 'Not selected (enter manually below)',
    },
  },
  kz: {
    ogpovts: {
      is_beneficiary: 'Бенефициар болып табылады',

      bannerOgpoJusan: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/failure_W_2016х158_kz.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/failure_B_2016х158_kz.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/failure_W_343x100_kz.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/failure_B_343x100_kz.png',
      },
      title: 'Міндетті автосақтандыру (КҚИАҚЖАМС)',
      calculator: 'Сақтандыру калькуляторы',
      'description.title': 'Сипаттамасы',
      'description.text':
        'Полис болмаған жағдайда, әсерлі айыппұл қарастырылған. Жол апаты болған жағдайда, егер сіз кінәлі болсаңыз, бұл саясат сіздің азаматтық-құқықтық жауапкершілігіңізді қамтиды. Зардап шеккен тарапқа келтірілген залалды өтеу бойынша шығындарды сақтандыру компаниясы өз мойнына алады.\n\nКөлік құралының әрбір иесі, жүргізушісі "Көлік құралдары иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру туралы" 01.07.2003 ж. №446-II Қазақстан Республикасының Заңына сәйкес өз жауапкершілігін сақтандыруы тиіс.',
      cars: 'Автомобильдер',
      'cars.add': 'Автоны қосу',
      drivers: 'Жүргізушілер',
      drivers2: 'Жүргізушілер (көлік иесінің деректерін көрсетіңіз)',
      'drivers.add': 'Жүргізушіні қосу',
      '12months': '12 ай',
      '6months': '6 ай',
      period: 'Сақтандыру кезеңі',
      date: 'Шарттың басталатын күні',
      dateEnd: 'Шарттың бітетін күні',
      benefit: 'Жеңілдіктер бар',
      agree: ' келісемін және ',
      'agree.color3': ' жеке деректерді жинауға және өңдеуге',
      'agree.color4': 'Міндетті автосақтандырудың ережелерімен',
      'agree.color5': 'Жазатайым оқиғадан сақтандыру ережелерімен ',
      'agree.color6': 'титулдық сақтандыру ережелерімен',
      'agree.color88': ' автомобильді ерікті сақтандыру ережелерімен',
      agree3: ' келісімімді растаймын, сондай-ақ ',
      'agree.color': ' сақтандыру ережелерімен ',
      'agree.color2': 'акция шарттарымен ',
      agree2: ' таныстым',
      'agree2.color': 'құпиялылық саясатымен',
      snackbarError: 'Қате. Кейінірек көріңіз',
      snackbarDownload: 'Файл жүктелуде, күтуіңізді сұраймыз',
      price: 'Төлемге',
      button: 'Сатып алу',
      or: 'немесе',
      and: ' келісемін және ',
      IIN: 'ЖСН',
      promotion:
        'Біздің компанияның акциясын таңдаңыз. Акцияны таңдай отырып, сіз акцияның шарттарымен келісесіз',
      promotion2:
        'ТЕК 24 ҚАРАША! "Orange Friday " арнайы іс-шарасына сәйкес таңдалған науқанға қоса Сіз 10 литр бензин аласыз! Толығырақ ',
      'promotion2.button': 'осында',
      phoneNumber1: 'Полис ұстаушының телефон нөмірін енгізіңіз: ',
      phoneNumber2: 'Телефон нөмірі',
      SMS: 'SMS кодын жіберіңіз',
      cancel: 'Бас тарту',
      validate1: 'Автокөліктің нөмірі қате',
      validate2: 'Автокөліктің мемлекеттік нөмірін енгізіңіз',
      validate3: 'ЖСН 12 таңбадан тұру қажет',
      validate4: 'Техникалық қателік, қайталап көріңіз',
      validate5:
        'Мемлекеттік нөмір форматы А000ААА немесе 000ААА00 форматына сәйкес келмейді',
      widget1: widget_kz,
      widget2: widget2_kz,
      widget3: widget3_kz,
      widget4: widget4_kz,
      widget5: widget5_kz,
      widget6: widget6_kz,
      bmgError:
        'Ағымдағы ЖСН үшін, egov.kz сайтының жеке кабинетінде басқа телефон нөмірі расталды. Дұрыс телефон нөмірін енгізіңіз',
      mcPr1:
        'Осы өтініш-сауалнаманы растай отырып, автомобильді ерікті сақтандыру полисін жасасуға өз келісімімді беремін',
      mcPr2:
        'Осы өтініш-сауалнаманы растай отырып, автомобильді ерікті сақтандыру полисін және ерікті титулдық сақтандыру полисін жасасуға өз келісімімді беремін',
      heIsdriver: 'Жүргізуші',
      insurant_label: '(Сақтанушы)',
      driver_label: '(Жүргізуші)',
      application_success: 'Өтінім сәтті жіберілді!',
      application_followup: 'Сізбен жақын арада хабарласады',
      'ОГПО ВТС': 'КҚИ АҚЖМС',
      'Несчастный случай': 'Жазатайым оқиға',
      НС: 'ЖО',
      'Страховка от несчастного случая': 'Жазатайым оқиғадан сақтандыру',
      'Страховая сумма на одного застрахованного':
        'Бір сақтандырылғанға арналған сақтандыру сомасы',
      'Территория страхования': 'Сақтандыру аумағы',
      'Срок страхования': 'Сақтандыру мерзімі',
      'Количество застрахованных': 'Сақтандырылғандар саны',
      'Дата начала договора': 'Шарттың басталатын күні',
      Закрыть: 'Жабу',
      месяцев: 'ай',
      'Сбросить на 12 мес.': '12 айға қайта орнату',
    },
    cascoLimit: {
      sumInsured: 'Сақтандыру сомасы',
      termOfInsurance: 'Сақтандыру мерзімі',
      months: '12 ай',
      purposeOfUse: 'Пайдалану мақсаты',
      personal: 'Жеке',
      other: 'Өзге',
      beneficiary: 'Көлік иеcі',
      yourVehicles: 'Сіздің көліктеріңіз',
      detailsTitle: 'Полис мәліметтері',
      detailsDescription: 'Полис мәліметтерінің дұрыстығын тексеріңіз',
      insuredCount: 'Сақтандырылғандар саны',
      regNumber: 'Көлік нөмірі',
      startDate: 'Шарттың басталу күні',
      endDate: 'Шарттың аяқталу күні',
      premium: 'Сақтандыру сыйақысы',
      not_selected_manual: 'Таңдалмаған (төменде қолмен енгізіңіз)',
    },
  },
  ru: {
    ogpovts: {
      bannerOgpoJusan: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/failure_W_2016х158_ru.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/failure_B_2016х158_ru.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/failure_W_343x100_ru.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/failure_B_343x100_ru.png',
      },
      title: 'Обязательное автострахование (ОГПО ВТС)',
      calculator: 'Калькулятор страхования',
      'description.title': 'Описание',
      'description.text':
        'При отсутствии полиса предусмотрен внушительный штраф. Данный полис покрывает вашу гражданско-правовую ответственность в случае ДТП если виновником являетесь вы. Расходы по возмещению ущерба пострадавшей стороне берет на себя страховая компания.\n\nКаждый владелец, водитель транспортного средства должен застраховать свою ответственность в соответствии с Законом Республики Казахстан №446-II от 01.07.2003 г. «Об обязательном страховании гражданско-правовой ответственности владельцев транспортных средств».',
      cars: 'Автомобили',
      'cars.add': 'Добавить авто',
      drivers: 'Водители',
      drivers2: 'Водители (укажите собственника авто)',
      'drivers.add': 'Добавить водителя',
      '12months': '12 месяцев',
      '6months': '6 месяцев',
      period: 'Период страхования',
      date: 'Дата начала договора',
      dateEnd: 'Дата конца договора',
      benefit: 'Имеется льгота',
      agree: 'Я подтверждаю ',
      'agree.color3': 'согласие на сбор и обработку персональных данных',
      agree3: ', а также соглашаюсь ',
      'agree.color': 'с правилами страхования',
      'agree.color4': 'с правилами страхования ОГПО ВТС',
      'agree.color5': 'с правилами от Несчастного случая',
      'agree.color6': 'титульного страхования',
      'agree.color88': 'с правилами добровольного автомобильного страхования',
      'agree.color2': 'с условиями акции ',
      agree2: 'и ознакомлен(а) с ',
      'agree2.color': 'политикой конфиденциальности',
      snackbarError: 'Ошибка. Пожалуйста попробуйте позднее',
      snackbarDownload: 'Файл скачивается. Пожалуйста подождите',
      price: 'К оплате',
      button: 'Купить',
      or: 'или',
      and: ' и ',
      IIN: 'ИИН',
      promotion:
        'Выберите акцию от нашей компании. Выбирая акцию Вы соглашаетесь с условиями акции',
      promotion2:
        'ТОЛЬКО 24 НОЯБРЯ! Согласно специальному событию "Orange Friday" к выбранной акции вы получите 10 литров бензина в подарок! Подробнее ',
      'promotion2.button': 'здесь',
      phoneNumber1: 'Введите номер телефона страхователя: ',
      phoneNumber2: 'Номер телефона',
      SMS: 'Отправить SMS код',
      cancel: 'Отмена',
      validate1: 'Некорректный номер авто',
      validate2: 'Введите гос. номер авто',
      validate3: 'ИИН должен состоять из 12 символов',
      validate4: 'Техническая проблема, попробуйте еще раз',
      validate5:
        'Формат гос. номера не соответствует формату A000AAA или 000ААА00',
      widget1: widget_ru,
      widget2: widget2_ru,
      widget3: widget3_ru,
      widget4: widget4_ru,
      widget5: widget5_ru,
      widget6: widget6_ru,
      bmgError:
        'За текущим ИИН подтвержден другой номер телефона в личном кабинете сайта egov.kz. Внесите корректный номер телефона',
      mcPr1:
        'Подтверждая настоящее заявление-анкету, даю свое согласие на заключение полиса добровольного автомобильного страхования',
      mcPr2:
        'Подтверждая настоящее заявление-анкету, даю свое согласие на заключение полиса добровольного автомобильного страхования и полиса добровольного титульного страхования',
      heIsdriver: 'Он же водитель',
      is_beneficiary: 'Является выгодоприобретателем',
      insurant_label: '(Страхователь)',
      driver_label: '(Водитель)',
      application_success: 'Заявка успешно отправлена!',
      application_followup: 'С вами свяжутся в ближайшее время',
      'ОГПО ВТС': 'ОГПО ВТС',
      'Несчастный случай': 'Несчастный случай',
      НС: 'НС',
      'Страховка от несчастного случая': 'Страховка от несчастного случая',
      'Страховая сумма на одного застрахованного':
        'Страховая сумма на одного застрахованного',
      'Территория страхования': 'Территория страхования',
      'Срок страхования': 'Срок страхования',
      'Количество застрахованных': 'Количество застрахованных',
      'Дата начала договора': 'Дата начала договора',
      Закрыть: 'Закрыть',
      месяцев: 'месяцев',
      'Сбросить на 12 мес.': 'Сбросить на 12 мес.',
    },

    cascoLimit: {
      sumInsured: 'Страховая сумма',
      termOfInsurance: 'Срок страхования',
      months: '12 месяцев',
      purposeOfUse: 'Цель использования',
      personal: 'Личная',
      other: 'Иное',
      beneficiary: 'Выгодоприобретатель (Владелец ТС)',
      yourVehicles: 'Ваши автомобили',
      detailsTitle: 'Детали полиса',
      detailsDescription: 'Пожалуйста, проверьте данные полиса на корректность',
      insuredCount: 'Количество застрахованных',
      regNumber: 'Номер авто',
      startDate: 'Дата начала договора',
      endDate: 'Дата окончания договора',
      premium: 'Премия',
      not_selected_manual: 'Не выбрано (ввести вручную ниже)',
    },
  },
};

export default ogpovtsResources;
